import script from "./SecondSaiPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondSaiPage.vue?vue&type=script&setup=true&lang=js"

import "./SecondSaiPage.vue?vue&type=style&index=0&id=772ff921&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-772ff921"]])

export default __exports__